module.exports = __webpack_public_path__ + "a57c2f3634ec07ad89ccb458dd981e9b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/left_hand.png
// module id = 1143
// module chunks = 0